module.exports = __webpack_public_path__ + "img/pay-arrow-top.fbafe7b6.png";